import { gql } from "@apollo/client";

export const employeeData = {
  email: "",
  employeeCode: "",
  employeeName: "",
  contactNumber: "",
  address: "",
  role: "",
  department: "",
  profilePicture: null,
  mobileUse: true,
  webUse: false,
  isActive: false,

  emailStatus: "unchecked",
  employeeCodeStatus: "unchecked",
  employeeNameStatus: "unchecked",
  contactNumberStatus: "unchecked",
  addressStatus: "unchecked",
  roleStatus: "unchecked",
  departmentStatus: "unchecked",
  profilePictureStatus: false,
};

export const employeeDataMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "employeeCode": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          employeeCode: value,
          employeeCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          employeeCode: "",
          employeeCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          employeeCode: value,
          employeeCodeStatus: "error",
        };
      }
    }
    case "contactNumber": {
      //  const alphaNLenghthRegex = new RegExp("^\\d{8,15}$");
      const alphaNLenghthRegex = new RegExp("^\\d{8}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          contactNumber: value,
          contactNumberStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          contactNumber: "",
          contactNumberStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          contactNumber: value,
          contactNumberStatus: "error",
        };
      }
    }
    case "employeeName": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          employeeName: value,
          employeeNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          employeeName: "",
          employeeNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          employeeName: value,
          employeeNameStatus: "error",
        };
      }
    }
    case "email": {
      const alphaNLenghthRegex = new RegExp(
        "^[\\w.-]+@[\\w.-]+\\.[a-zA-Z]{2,}$"
      );
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          email: value,
          emailStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          email: "",
          emailStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          email: value,
          emailStatus: "error",
        };
      }
    }
    case "role": {
      if (value) {
        return {
          ...state,
          role: value,
          roleStatus: "success",
        };
      } else {
        return {
          ...state,
          role: "",
          roleStatus: "unchecked",
        };
      }
    }
    case "department": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          department: value,
          departmentStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          department: "",
          departmentStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          department: value,
          departmentStatus: "error",
        };
      }
    }
    case "address": {
      const alphaNLenghthRegex = new RegExp("^.{1,10000}$", "s");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          address: value,
          addressStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          address: "",
          addressStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          address: value,
          addressStatus: "error",
        };
      }
    }
    case "mobileUse": {
      return {
        ...state,
        mobileUse: value,
      };
    }
    case "webUse": {
      return {
        ...state,
        webUse: value,
      };
    }
    case "isActive": {
      return {
        ...state,
        isActive: value,
      };
    }
    case "profilePicture": {
      if (value) {
        return {
          ...state,
          profilePicture: value,
          profilePictureStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          profilePicture: null,
          profilePictureStatus: false,
        };
      }
    }

    default:
      return state;
  }
};

export const allUsers = gql`
  query {
    allUsers {
      id
      employeeName
      employeeCode
      email
      contactNumber
      address
      role {
        id
        role
      }

      department
      createdAt

      profilePicture

      webUse

      mobileUse
      isActive
    }
  }
`;

export const createemployee = gql`
  mutation createemployee($input: CreateUserInput!) {
    createUser(input: $input) {
      success
      message
      error
    }
  }
`;

export const updateUser = gql`
  mutation updateemployee($input: UpdateUserInput!) {
    updateUser(input: $input) {
      success
      message
    }
  }
`;
